import { Component } from '@theme/component';

/** @extends {Component<{controls: HTMLElement, search: HTMLInputElement, cards: HTMLElement[], count: HTMLElement, empty: HTMLElement}>} */
class MoyuuBrandDirectory extends Component {
  letter = 'all';
  connectedCallback() {
    super.connectedCallback();
    if (this.refs.controls instanceof HTMLElement) this.refs.controls.hidden = false;
    this.filterBrands();
  }
  updatedCallback() {
    super.updatedCallback();
    if (this.refs.controls instanceof HTMLElement) this.refs.controls.hidden = false;
    this.filterBrands();
  }
  filterBrands() {
    const input = this.refs.search;
    const query = input instanceof HTMLInputElement ? input.value.trim().toLocaleLowerCase() : '';
    const cards = Array.isArray(this.refs.cards) ? this.refs.cards : [];
    let count = 0;
    for (const card of cards) {
      if (!(card instanceof HTMLElement)) continue;
      const name = card.dataset.brand || '';
      const first = name.charAt(0).toUpperCase();
      const matchesLetter = this.letter === 'all' || (this.letter === '#' ? !/^[A-Z]$/.test(first) : first === this.letter);
      card.hidden = !matchesLetter || !name.toLocaleLowerCase().includes(query);
      if (!card.hidden) count += 1;
    }
    if (this.refs.count instanceof HTMLElement) this.refs.count.textContent = count + ' ' + (query || this.letter !== 'all' ? this.dataset.foundLabel : this.dataset.countLabel);
    if (this.refs.empty instanceof HTMLElement) this.refs.empty.hidden = count > 0;
  }
  /** @param {MouseEvent} event */
  selectLetter(event) {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const button = target.closest('button[data-letter]');
    if (!(button instanceof HTMLButtonElement)) return;
    this.letter = button.dataset.letter || 'all';
    for (const item of this.querySelectorAll('button[data-letter]')) item.setAttribute('aria-pressed', String(item === button));
    this.filterBrands();
  }
  resetFilters() {
    this.letter = 'all';
    if (this.refs.search instanceof HTMLInputElement) this.refs.search.value = '';
    for (const button of this.querySelectorAll('button[data-letter]')) button.setAttribute('aria-pressed', String(button.getAttribute('data-letter') === 'all'));
    this.filterBrands();
    if (this.refs.search instanceof HTMLInputElement) this.refs.search.focus();
  }
}
if (!customElements.get('moyuu-brand-directory')) customElements.define('moyuu-brand-directory', MoyuuBrandDirectory);
